module.exports = __webpack_public_path__ + "static/media/bigbag-inactive.afc40f85.svg";